<template>
  <div class="container">
    <transition name="fade">
      <nav-panel v-show="showNavPanel" class="nav-panel"></nav-panel>
    </transition>
    <div>
      <page-header></page-header>
      <transition name="silde">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>
<script>
import NavPanel from "./nav.vue"
import mapStore from '@/mixins/mapStore'
export default {
  components: {
    NavPanel,
  },
  mixins: [
    mapStore('', {
      states: ['showNavPanel']
    })
  ]
};
</script>
<style lang="less" scoped>
.nav-panel {
  position: fixed;
  width: 100%;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(12px);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.silde-enter-active {
  transition: opacity 0.5s;
}
.silde-enter {
  opacity: 0;
}
</style>
